<template>
  <v-card>
    <v-card-text>
      <h2><v-icon>shopping_cart</v-icon>Referrer</h2>
      <template v-if="selectedHeaderElement != 1">
        <v-layout row>
          <v-flex md8>
            <div>
              <strong>Referrer</strong>
            </div>
            <div>
              <router-link
                :to="{ name: 'referrer', params: { id: quote.referrer.id } }"
                v-if="quote.referrer"
                >{{ quote.referrer.name }}</router-link
              >
              <span v-if="!quote.referrer">{{ quote.referrer.id }}</span
              >&#160;
              <span v-if="quote.leadid">{{ quote.leadid }}</span>
            </div>
          </v-flex>
          <v-flex md4>
            <v-btn @click="$emit('changeSelectedHeaderElement', 1)" small>
              <v-icon>edit</v-icon>Change
            </v-btn>
            <v-btn @click="reprocessQuote" v-if="reprocess" small>
              <v-icon>cached</v-icon>Reprocess
            </v-btn>
          </v-flex>
        </v-layout>
      </template>
      <div class="ajaxForm" v-if="selectedHeaderElement == 1">
        <v-select
          label="Referrer"
          v-model="referrerid"
          :items="referrers"
          item-value="id"
          box
        >
          <template v-slot:selection="data">{{
            nameFormatted(data.item.name)
          }}</template>
          <template v-slot:item="data">{{
            nameFormatted(data.item.name)
          }}</template>
        </v-select>
        <v-btn @click="updateReferrer">
          <v-icon>save</v-icon>Change referrer
        </v-btn>
        <v-btn @click="$emit('changeSelectedHeaderElement', 0)">
          <v-icon>undo</v-icon>Cancel
        </v-btn>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import nbmlaw from "@/api/nbmlaw";
import { nameFormatted } from "@/util/helpers";
export default {
  name: "Referrer",
  props: ["quote", "lastUpdated", "selectedHeaderElement"],
  computed: {
    reprocess() {
      if (
        this.referrer &&
        this.quote.leadid &&
        this.quote.referrer &&
        [41918, 134343, 35035].includes(this.quote.referrer.id)
      ) {
        return true;
      }
      return false;
    }
  },
  data() {
    return {
      referrers: null,
      referrerid: null
    };
  },
  methods: {
    nameFormatted,
    async fetchReferrers() {
      const response = await nbmlaw.get(
        `/cors/admin/directory/types/13/entities`
      );
      // console.log(response.data);
      this.referrers = response.data;
    },
    async reprocessQuote() {
      if (confirm("Are you sure?")) {
        await nbmlaw.put(
          `/cors/admin/sales/quotes/${this.quote.id}/reprocess`,
          null
        );
        // console.log(response.data);
        this.$emit("changeSelectedHeaderElement", 0);
      }
    },
    async updateReferrer() {
      await nbmlaw.put(
        `/cors/admin/sales/quotes/${this.quote.id}/referrer/${this.referrerid}`,
        null
      );
      // console.log(response.data);
      this.$emit("changeSelectedHeaderElement", 0);
    }
  },
  watch: {
    lastUpdated: {
      immediate: true,
      handler() {
        this.fetchReferrers();
      }
    },
    quote: {
      immediate: true,
      handler() {
        if (this.quote && this.quote.referrer) {
          this.referrerid = this.quote.referrer.id;
        }
      }
    }
  }
};
</script>